import AccountCreation from './AccountCreation';
import PracticeInformation from './PracticeInformation';

export default {
  AccountCreation,
  PracticeInformation,
};
